import PropTypes from 'prop-types';
export var crossPromotionPropTypes = PropTypes.shape({
  similarProperties: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  query: PropTypes.shape({}),
  attempts: PropTypes.arrayOf(PropTypes.shape({
    duration: PropTypes.number.isRequired,
    resultCount: PropTypes.number.isRequired
  })).isRequired,
  maxDuration: PropTypes.number,
  minResults: PropTypes.number,
  limit: PropTypes.number
});